import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  fetchNotificationsBirthday,
  createNotificationsBirthday,
  updateNotificationsBirthday,
  deleteNotificationsBirthday,
} from "./thunks";
import type { BirthdayNotificationTemplate } from "@/types/notifications";

interface NotificationsBirthdayState {
  data: BirthdayNotificationTemplate[] | null;
  loading: boolean;
  error: any | null;
}

const initialState: NotificationsBirthdayState = {
  data: null,
  loading: false,
  error: null,
};

const NotificationsBirthdaySlice = createSlice({
  name: "notificationsBirthday",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchNotificationsBirthday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationsBirthday.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        if (Array.isArray(payload))
          state.data = payload as BirthdayNotificationTemplate[];
        else if (payload && payload.data)
          state.data = payload.data as BirthdayNotificationTemplate[];
        else
          state.data = payload
            ? ([payload] as BirthdayNotificationTemplate[])
            : null;
      })
      .addCase(fetchNotificationsBirthday.rejected, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        if (payload?.skip) {
          // skip setting error on expected 401 to wait for session refresh
          return;
        }
        state.error = payload || action.error;
      })

      .addCase(createNotificationsBirthday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNotificationsBirthday.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as BirthdayNotificationTemplate | null;
        if (payload) state.data = [payload, ...(state.data || [])];
        toast.success("Template criado");
      })
      .addCase(createNotificationsBirthday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao criar template");
      })

      .addCase(updateNotificationsBirthday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateNotificationsBirthday.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload as BirthdayNotificationTemplate;
        state.data = (state.data || []).map((t) =>
          t.id === updated.id ? updated : t,
        );
        toast.success("Template atualizado");
      })
      .addCase(updateNotificationsBirthday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao atualizar template");
      })

      .addCase(deleteNotificationsBirthday.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteNotificationsBirthday.fulfilled, (state, action) => {
        state.loading = false;
        const id = action.meta.arg as number as number;
        state.data = (state.data || []).filter((t) => t.id !== id);
        toast.info("Template excluído");
      })
      .addCase(deleteNotificationsBirthday.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
        toast.error("Falha ao excluir template");
      }),
});

export default NotificationsBirthdaySlice.reducer;
